import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../lib/domain';
import { BasicHeader } from '../../components/basic_header';
import ErrorWrapper from '../../lib/error_wrapper';
import { NetworkDelaySearch, defaultDateFormat, formatMoney, showErrorInNotification, showSuccessInNotification } from '../../lib/util';
import { Input, Table, Button, Checkbox, Modal,Typography,Descriptions } from 'antd';
import { Link } from 'react-router-dom';
import FilterFixedInput from '../../components/filter_fixed_input';
import NetworkSelect from '../../lib/ui/network_select';
import CustomDateRangePicker from '../../components/custom_date_range';
import moment from 'moment';

const { Title, Text, Paragraph } = Typography;

const queryString = require('query-string');


class StoreFileCountList extends Component {

    constructor(props) {
        super(props)

        this.state = {
            filter_query: {},
            selectedIDs:[],
            selectedTxnForView:null,
        }

        this.listDataExecutor = RESTExecutor.list().config({
            label: 'list_store_files'
        }).connect(props.domains.store);


        // this.resendExecutor=RESTExecutor.post().config({
        //     label:'list'
        // }).callbacks((success)=>{
        //     showSuccessInNotification(success,"Transaction sent for reprocessing");
        //     this.setState({
        //         selectedIDs:[]
        //     })
        //     this.listDataExecutor.execute();
        // },(error)=>{
        //     showErrorInNotification(error);
        // }).connect(props.domains.failedTransaction);

        // this.listDataExecutor.execute()

        this.delay_search = new NetworkDelaySearch();

    }


    stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

    onSelect=(id)=>{
        let newId=this.state.selectedIDs??[];
        const indexNumber=newId.indexOf(id);
        if(indexNumber===-1){
            newId.push(id);
        }else{
            newId.splice(indexNumber,1);
        }
        
        console.log("indexNumber",indexNumber,newId)
        this.setState({
            selectedIDs:newId
        })
    }

    onSelectAll=(listData=[])=>{
        let newIds=listData.map((a)=>a.packet_id);
        this.setState({
            selectedIDs:newIds
        })
    }
    render() {

        let listDataExecutor_resp = this.listDataExecutor.response()
        // const resendExecutorResp=this.resendExecutor.response();
        const {filter_query,selectedIDs,selectedTxnForView}=this.state;
        let rowsData = (listDataExecutor_resp.result&&listDataExecutor_resp.result.rows )|| [];
        let rowsMeta = listDataExecutor_resp.meta || {};
        return (
            <div>
                <BasicHeader
                    menu_items={[]} 
                    no_back
                    title="Store Files"
                />
                 <div className='filter-card'>
                    {/* <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',
                    }}>
                        <Input.Search
                            placeholder="Search For"
                            style={{
                            }} autoFocus
                            value={filter_query.query}
                            onChange={(e) => {
                                this.stateUpdater({
                                    stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {

                                        this.delay_search.onSearch(() => {

                                            this.props.history.push({
                                                // pathname:"users",
                                                search: queryString.stringify({ ...this.state.filter_query })
                                            })
                                        })

                                    }
                                })
                            }} />
                    </div> */}
                    <div
            style={{
              display: "flex",
              flexDirection: "row",
              // justifyContent: 'space-between',
              flexWrap: "wrap",
              paddingTop: 4,
              paddingBottom: 4,
            }}
          >
            <FilterFixedInput label="Date Range" >
                            <CustomDateRangePicker
                                style={{
                                    // width: 400,
                                    // marginLeft: 16,
                                    flex: null
                                }}
                                allowClear
                                startDate={filter_query.from_date ? moment(filter_query.from_date, defaultDateFormat) : null}
                                endDate={filter_query.to_date ? moment(filter_query.to_date, defaultDateFormat) : null}
                                onChange={(dates) => {
                                    //   console.log("GOT DATES",dates.startDate.toISOString(),dates.endDate.toISOString())
                                    this.stateUpdater({
                                        stateKey: 'filter_query', appendObj: {
                                            from_date: dates.startDate?dates.startDate.format(defaultDateFormat):undefined,
                                            to_date: dates.endDate?dates.endDate.format(defaultDateFormat):undefined,page: 1
                                        },
                                        callback: () => {
                                            this.props.history.push({
                                                search: queryString.stringify(this.state.filter_query)
                                            })
                                        }
                                    })
                                }}

                            />
                        </FilterFixedInput>
            <FilterFixedInput label="Store">
              <NetworkSelect
                value={filter_query.store_id}
                style={{ marginRight: 8 }}
                item={{
                  name: "Store",
                  className:
                    filter_query.store_id != null
                      ? "filter-option-selected"
                      : "",
                }}
                url={`/my-dashboards/store-list`}
                onChange={(received_value) => {
                  this.stateUpdater({
                    stateKey: "filter_query",
                    valueKey: "store_id",
                    value: received_value,
                    callback: () => {
                      this.props.history.push({
                        search: queryString.stringify({
                          ...this.state.filter_query,
                          page: 1,
                        }),
                      });
                    },
                  });
                  // this._change(item.index, received_value, d_key)
                }}
              />
            </FilterFixedInput>
          </div>
                </div>
                {selectedIDs.length>0&&
                <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        margin: 8,
                }}>
                <Button onClick={()=>{
                    this.resendExecutor.execute({
                        packet_ids:selectedIDs
                    })
                }} type='link'>Resend Selected</Button>
                </div>
                }

                {/* {selectedTxnForView&&<Modal
                 visible={true}
                 width={'90%'}
                 destroyOnClose
                 footer={null}
                 className='transaction-modal'
                 centered
                 onCancel={() => {
                   this.setState({
                     selectedTxnForView: null
                   })
                 }}
                >
                    <div style={{
                        display:'flex',
                        flexDirection:'column',
                        padding:'8px',
                        gap:'10px'
                    }}>
                    <Title>Packet ID: {selectedTxnForView?.packet_id}</Title>
                     <Descriptions className='small-description' bordered size='small' layout='horizontal'>
                                                        {Object.keys(selectedTxnForView?.parsed_data).map((key) => {
                                                            if (!key.startsWith('__')) {
                                                                return <Descriptions.Item key={key} label={key} className='log-text' >
                                                                    <Paragraph >
                                                                        {typeof selectedTxnForView?.parsed_data[key] === 'string' ? selectedTxnForView?.parsed_data[key] : JSON.stringify(selectedTxnForView?.parsed_data[key])}
                                                                    </Paragraph>
                                                                </Descriptions.Item>

                                                            }
                                                        })}
                                                    </Descriptions>
                                                    </div>
                    </Modal>} */}
               
                <ErrorWrapper
                error={listDataExecutor_resp}
                onReload={()=>{
                    this.listDataExecutor.execute()
                }}
                >
                     <div className='default-card' style={{
                    // padding: 8
                }}>
                     <Table
                        // rowClassName='hand-cursor'
                        className='main-table noHover'
                        loading={listDataExecutor_resp.fetching}
                        size='small'
                        scroll={{ x: true }}
                        pagination={false}
                        // pagination={{
                        //     // simple: true,
                        //     position:'bottom',
                        //     onChange: (current, size) => {
                        //         this.props.history.push({
                        //             search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                        //         })

                        //     },
                        //     defaultCurrent: 1,
                        //     current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                        //     // defaultPageSize: 20,
                        //     pageSize: (rowsMeta && rowsMeta.requested_count),

                        //     total: (rowsMeta && rowsMeta.total_count),
                        //     showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                        // }}
                        rowKey={(record) => record.packet_id}
                        columns={[
                            // {
                            //     title:<Checkbox checked={selectedIDs.length===rowsData.length} onChange={()=>{
                            //         this.onSelectAll(selectedIDs.length===rowsData.length?[]:rowsData);
                            //     }}/>,
                            //     dataIndex:'packet_id',
                            //     key:'packet_id',
                            //     width:50,
                            //     render:(packet_id)=>{
                            //         return <Checkbox checked={selectedIDs.includes(packet_id)} onChange={()=>{
                            //             this.onSelect(packet_id);
                            //         }} />
                            //     }
                            // },
                            {
                               title:"Date",
                               dataIndex:'date',
                              // width:200,
                               key:'date'

                            },
                            { 
                                title:"Store",
                                dataIndex:'store',
                                key:'store'
                            },
                            {
                                title:"Count",
                                dataIndex:'count',
                                key:'count'
                            },
                            // {
                            //     title: "", dataIndex: "packet_id", 
                            //     width:80,
                            //     key: 'id', render: (id,record) => {
                            //         return <div style={{
                            //             display:'flex',
                            //             flexDirection:'row',
                            //             alignItems:'center',
                            //             gap:'10px'
                            //         }}> 
                            //         {/* <Button onClick={()=>{
                            //             this.setState({
                            //                 selectedTxnForView:record
                            //             })
                            //          }} type='link'>View</Button> */}
                            //          <Button onClick={()=>{
                            //             this.resendExecutor.execute({
                            //                 packet_ids:[id]
                            //             })
                            //          }} type='link'>Resend</Button>
                            //         {/* <Link to={{
                            //             pathname: `/activity/cache/${id}`,
                            //             // search: `datatype=${id}`
                            //         }}
                            //         style={{color:'inherit'}}
                            //         >
                            //             <Button type='link'>View</Button>
                            //         </Link>
                            //              */}

                            //         </div>
                            //     }
                            // }
                        ]}
                        dataSource={rowsData}
                    />
                    </div>
                </ErrorWrapper>
            </div>
        );
    }

    componentDidMount() {
        let new_filter_query = {};
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        this.setState({
            filter_query: {
                ...new_filter_query
            }
        }, () => {
            this.listDataExecutor.config({
                params: {
                    ...this.state.filter_query
                }
            }).execute()
        })
    }

    componentWillReceiveProps(nextProps) {

        let new_filter_query = {};
        if ((this.props.location.search !== nextProps.location.search)) {
            const parsed = queryString.parse(nextProps.location.search);
            new_filter_query = parsed;
            this.setState({
                filter_query: {
                    ...new_filter_query
                }
            }, () => {
                this.listDataExecutor.config({
                    params: {
                        ...this.state.filter_query
                    }
                }).execute()
            })
        } 


    }

}

export default withDomains(StoreFileCountList, "store");
